module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/comment-stars-five-6879fcc34a3272e9447fec9960b24e3d.png";